


// // ********** AddSubjectForm.jsx - Version OPTIMISÉE avec endpoint léger *****************
// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Editor } from "@tinymce/tinymce-react";
// import axios from "axios";
// import authHeader from "../../services/auth-header";
// import { Checkbox, Select, Input, Button, message } from "antd";
// import courseService from "../../services/course.service";
// import API_BASE from "../../config/apiConfig";

// const { Option } = Select;

// const PROXY_BASE_URL = `${API_BASE}/images/proxy?url=`;
// const METADATA_URL = `${API_BASE}/images/metadata/`;

// const getProxyUrl = (fileId) => {
//     const downloadUrl = `https://drive.google.com/uc?id=${fileId}&export=view`;
//     return PROXY_BASE_URL + encodeURIComponent(downloadUrl);
// };

// const isGoogleDriveUrl = (url) => {
//     if (!url) return false;
//     return url.includes('drive.google.com') || 
//            url.includes('drive.usercontent.google.com') ||
//            url.includes('googleapis.com/drive');
// };

// const extractFileId = (url) => {
//     if (!url) return null;
//     let match = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) ||
//                 url.match(/[?&]id=([a-zA-Z0-9_-]+)/) ||
//                 url.match(/\/d\/([a-zA-Z0-9_-]+)/);
//     return match ? match[1] : null;
// };

// const transformExistingSrc = (content) => {
//     if (!content || typeof content !== 'string') return content;
    
//     let transformed = content
//         .replace(/http:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
//         .replace(/https:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
//         .replace(/http:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
//         .replace(/https:\/\/localhost:8080\/api\//g, `${API_BASE}/`);
    
//     transformed = transformed
//         .replace(/src="\/api\//g, `src="${API_BASE}/`)
//         .replace(/src='\/api\//g, `src='${API_BASE}/`)
//         .replace(/href="\/api\//g, `href="${API_BASE}/`)
//         .replace(/href='\/api\//g, `href='${API_BASE}/`);
    
//     transformed = transformed.replace(
//         /<video([^>]*)>/gi,
//         (match, attrs) => {
//             let newAttrs = attrs.replace(/controlsList="[^"]*"/gi, '').replace(/controlslist="[^"]*"/gi, '');
//             newAttrs += ' controlsList="nodownload nofullscreen noremoteplayback"';
//             if (!attrs.includes('disablePictureInPicture')) newAttrs += ' disablePictureInPicture';
//             if (!attrs.includes('oncontextmenu')) newAttrs += ' oncontextmenu="return false;"';
//             newAttrs = newAttrs.replace(/\s+/g, ' ').trim();
//             return `<video ${newAttrs}>`;
//         }
//     );
    
//     transformed = transformed.replace(
//         /(<img[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
//         (match, prefix, url, suffix) => {
//             if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
//                 const fileId = extractFileId(url);
//                 if (fileId) return prefix + getProxyUrl(fileId) + suffix;
//             }
//             return match;
//         }
//     );
    
//     transformed = transformed.replace(
//         /(<source[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
//         (match, prefix, url, suffix) => {
//             if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
//                 const fileId = extractFileId(url);
//                 if (fileId) return prefix + getProxyUrl(fileId) + suffix;
//             }
//             return match;
//         }
//     );
    
//     transformed = transformed.replace(
//         /(<video[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
//         (match, prefix, url, suffix) => {
//             if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
//                 const fileId = extractFileId(url);
//                 if (fileId) return prefix + getProxyUrl(fileId) + suffix;
//             }
//             return match;
//         }
//     );
    
//     return transformed;
// };

// const AddSubjectForm = ({ courseId: propCourseId, subject: existingSubject, onClose, onSaved }) => {
//     const params = useParams();
//     const navigate = useNavigate();
//     const courseId = propCourseId || params.courseId || existingSubject?.courseId;
    
//     const [subject, setSubject] = useState({
//         group_name: existingSubject?.group_name || "",
//         title: existingSubject?.title || "",
//         subTitle: existingSubject?.subTitle || "",
//         content: existingSubject?.content || "",
//     });
    
//     const [groups, setGroups] = useState([]);
//     const [isNewGroup, setIsNewGroup] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [loadingGroups, setLoadingGroups] = useState(false);
//     const [error, setError] = useState(null);
//     const [success, setSuccess] = useState(false);
//     const [isNewTitle, setIsNewTitle] = useState(false);
//     const [titleOptions, setTitleOptions] = useState([]);
//     const [loadingTitles, setLoadingTitles] = useState(false);
//     const [initialLoadDone, setInitialLoadDone] = useState(false);
//     // ✅ Cache des données légères pour éviter les appels répétés
//     const [lightData, setLightData] = useState([]);
//     const editorRef = useRef(null);

//     useEffect(() => {
//         if (existingSubject) {
//             const transformedContent = transformExistingSrc(existingSubject.content || "");
//             setSubject({
//                 group_name: existingSubject.group_name || "",
//                 title: existingSubject.title || "",
//                 subTitle: existingSubject.subTitle || "",
//                 content: transformedContent,
//             });
//         }
//     }, [existingSubject]);

//     // ✅ UN SEUL appel API léger au chargement — remplace les 2 appels lourds
//     useEffect(() => {
//         const fetchGroupsLight = async () => {
//             setLoadingGroups(true);
//             try {
//                 const response = await axios.get(`${API_BASE}/courses/${courseId}/subjects/light`, {
//                     headers: authHeader()
//                 });
//                 const data = response.data || [];
//                 setLightData(data);
                
//                 const uniqueGroups = [...new Set(data.map((s) => s.group_name).filter(Boolean))];
//                 setGroups(uniqueGroups);
                
//                 if (subject.group_name) {
//                     const filteredTitles = data
//                         .filter((s) => s.group_name === subject.group_name)
//                         .map((s) => s.title)
//                         .filter(Boolean);
//                     setTitleOptions([...new Set(filteredTitles)]);
//                 }
//                 setInitialLoadDone(true);
//             } catch (err) {
//                 if (err.response?.status !== 204) {
//                     console.error("Erreur lors de la récupération des groupes :", err);
//                 }
//                 setInitialLoadDone(true);
//             } finally {
//                 setLoadingGroups(false);
//             }
//         };
//         if (courseId) fetchGroupsLight();
//     }, [courseId]);

//     // ✅ Filtrage local des titres — PLUS D'APPEL API quand on change de groupe
//     useEffect(() => {
//         if (!initialLoadDone || !subject.group_name) return;
        
//         const filteredTitles = lightData
//             .filter((s) => s.group_name === subject.group_name)
//             .map((s) => s.title)
//             .filter(Boolean);
//         const uniqueTitles = [...new Set(filteredTitles)];
//         setTitleOptions(uniqueTitles);
        
//         if (subject.group_name && !uniqueTitles.includes(subject.title)) {
//             setSubject((prev) => ({ ...prev, title: "" }));
//         }
//     }, [subject.group_name, lightData, initialLoadDone]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setSubject((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleGroupChange = (value) => {
//         setSubject((prev) => ({ ...prev, group_name: value }));
//     };

//     const handleCheckboxChange = (e) => {
//         setIsNewGroup(e.target.checked);
//         if (!e.target.checked) setSubject((prev) => ({ ...prev, group_name: "" }));
//     };

//     const getFileMetadata = async (fileId) => {
//         try {
//             const response = await axios.get(METADATA_URL + fileId);
//             return response.data;
//         } catch (error) {
//             console.error("❌ Erreur récupération métadonnées:", error);
//             return null;
//         }
//     };

//     const processGoogleDriveLink = async (fileId, fullUrl) => {
//         try {
//             const metadata = await getFileMetadata(fileId);
            
//             if (!metadata || metadata.error) {
//                 message.error("⚠️ Fichier non accessible.");
//                 return `<p style="color: red;">⚠️ Fichier non accessible (ID: ${fileId})</p>`;
//             }

//             const mimeType = metadata.mimeType || 'application/octet-stream';
//             const fileName = metadata.name || 'Fichier';
//             const fileSize = parseInt(metadata.size) || 0;
//             const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);
            
//             const proxyUrl = getProxyUrl(fileId);

//             if (mimeType.startsWith("image/")) {
//                 message.success(`🖼️ Image "${fileName}" ajoutée !`);
//                 return `<p><img src="${proxyUrl}" alt="${fileName}" style="width: 100%; max-width: 800px; height: auto; border-radius: 10px;" /></p>`;
                
//             } else if (mimeType.startsWith("video/")) {
//                 message.success(`🎬 Vidéo "${fileName}" (${fileSizeMB} MB) ajoutée !`);
//                 const videoId = `plyr_${Date.now()}`;
//                 return `<div class="video-wrapper" style="width: 100%; max-width: 800px; margin: 10px 0;">
//                     <div class="plyr__video-embed" id="${videoId}">
//                         <video playsinline controls data-poster="" style="width: 100%; border-radius: 10px;">
//                             <source src="${proxyUrl}" type="${mimeType}" />
//                         </video>
//                     </div>
//                     <p style="margin: 5px 0; font-size: 12px; color: #666;">🎬 ${fileName}</p>
//                 </div>`;
                
//             } else if (mimeType === "application/pdf") {
//                 message.success(`📄 PDF "${fileName}" ajouté !`);
//                 return `<p><a href="${proxyUrl}" target="_blank" rel="noopener" style="color: #1890ff; text-decoration: underline; font-weight: bold;">📄 Ouvrir le PDF : ${fileName}</a></p>`;
                
//             } else if (mimeType.startsWith("audio/")) {
//                 message.success(`🎵 Audio "${fileName}" (${fileSizeMB} MB) ajouté !`);
//                 return `<audio controls preload="metadata" style="width: 100%; max-width: 500px; margin: 10px 0;">
//                     <source src="${proxyUrl}" type="${mimeType}" />
//                 </audio>`;
                
//             } else {
//                 message.info(`📎 Fichier "${fileName}" ajouté comme lien`);
//                 return `<p><a href="${proxyUrl}" target="_blank" rel="noopener" style="color: #1890ff;">📎 Télécharger : ${fileName}</a></p>`;
//             }
//         } catch (error) {
//             console.error("❌ Erreur traitement fichier:", error);
//             message.error("⚠️ Erreur lors du traitement du fichier");
//             return `<p style="color: red;">⚠️ Erreur: ${error.message}</p>`;
//         }
//     };

//     const handleEditorChange = async (value, editor) => {
//         const googleDriveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)(\/view[^\s<"]*)?/g;
//         const matches = [...value.matchAll(googleDriveRegex)];
        
//         if (matches.length === 0) {
//             setSubject((prev) => ({ ...prev, content: value }));
//             return;
//         }

//         let processedValue = value;
        
//         for (const match of matches) {
//             const fullUrl = match[0];
//             const fileId = match[1];
            
//             const beforeMatch = value.substring(0, match.index);
//             if (beforeMatch.endsWith('src="') || 
//                 beforeMatch.endsWith("src='") || 
//                 beforeMatch.includes(`/file/d/${fileId}/preview`) ||
//                 beforeMatch.includes(`id=${fileId}`) ||
//                 beforeMatch.endsWith('href="')) {
//                 continue;
//             }
            
//             const embeddedContent = await processGoogleDriveLink(fileId, fullUrl);
//             processedValue = processedValue.replace(fullUrl, embeddedContent);
//         }
        
//         processedValue = transformExistingSrc(processedValue);
//         setSubject((prev) => ({ ...prev, content: processedValue }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError(null);

//         if (!subject.group_name || !subject.title) {
//             setError("Veuillez remplir tous les champs requis.");
//             setLoading(false);
//             return;
//         }

//         try {
//             const dataToSave = {
//                 ...subject,
//                 content: transformExistingSrc(subject.content),
//                 courseId
//             };

//             if (existingSubject?.id) {
//                 await courseService.updateSubject(existingSubject.id, dataToSave);
//             } else {
//                 await courseService.addSubjectToCourse(courseId, dataToSave);
//             }

//             setSuccess(true);
//             if (onSaved) await onSaved();
            
//             setTimeout(() => {
//                 if (onClose) onClose();
//                 else navigate("/mod/courses");
//             }, 1000);
//         } catch (err) {
//             setError(err.message || "Une erreur s'est produite.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const tinyMCEInit = {
//         height: 500,
//         menubar: true,
//         plugins: [
//             "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
//             "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
//             "insertdatetime", "media", "table", "help", "wordcount"
//         ],
//         toolbar: `undo redo | bold italic underline strikethrough | link image media |
//             alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
//             removeformat code help`,
//         content_style: `
//             body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }
//             video { max-width: 100%; border-radius: 10px; background: #000; min-height: 200px; }
//             audio { max-width: 100%; border-radius: 10px; }
//             .video-container { background: #f5f5f5; padding: 10px; border-radius: 10px; border: 1px solid #ddd; }
//             video::-internal-media-controls-download-button { display: none !important; }
//             video::-webkit-media-controls-download-button { display: none !important; }
//             video::-webkit-media-controls-enclosure { overflow: hidden !important; }
//             video::-webkit-media-controls-panel { width: calc(100% + 30px) !important; }
//             video::-moz-media-controls-download-button { display: none !important; }
//             video { -webkit-user-select: none !important; -moz-user-select: none !important; user-select: none !important; -webkit-touch-callout: none !important; -webkit-user-drag: none !important; }
//         `,
//         convert_urls: false,
//         relative_urls: false,
//         remove_script_host: false,
//         extended_valid_elements: 'video[controls|controlsList|controlslist|oncontextmenu|disablePictureInPicture|disablepictureinpicture|preload|style|src|type|width|height|id|class],audio[controls|controlsList|preload|style],source[src|type],div[class|style],p[style]',
//         custom_elements: 'video,audio,source',
//         valid_children: '+body[video|audio|div],+div[video|audio|div|p],+p[video|audio|span]',
//         media_live_embeds: true,
//         media_alt_source: false,
//         media_poster: false,
//         setup: (editor) => {
//             editor.on('BeforeSetContent', (e) => {
//                 if (e.content) e.content = transformExistingSrc(e.content);
//             });
//             editor.on('NodeChange', () => {
//                 const images = editor.dom.select('img');
//                 images.forEach(img => {
//                     const src = img.getAttribute('src');
//                     if (isGoogleDriveUrl(src) && !src.includes('/api/images/proxy')) {
//                         const fileId = extractFileId(src);
//                         if (fileId) img.setAttribute('src', getProxyUrl(fileId));
//                     }
//                 });
//             });
//         }
//     };

//     return (
//         <form onSubmit={handleSubmit}>
//             <h3>{existingSubject ? "Modifier le sujet" : "Ajouter un sujet"}</h3>
            
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">
//                 {existingSubject ? "Sujet mis à jour avec succès !" : "Sujet ajouté avec succès !"}
//             </div>}

//             <div className="mb-3">
//                 <label>Nom du Groupe</label>
//                 <Checkbox checked={isNewGroup} onChange={handleCheckboxChange} style={{ marginLeft: "10px" }}>
//                     Nouveau groupe ?
//                 </Checkbox>

//                 {isNewGroup ? (
//                     <Input type="text" name="group_name" className="form-control" value={subject.group_name}
//                         onChange={handleInputChange} required style={{ marginTop: "10px" }} />
//                 ) : (
//                     <Select showSearch className="form-control" value={subject.group_name || undefined}
//                         onChange={handleGroupChange} placeholder="Sélectionnez un groupe"
//                         style={{ width: "100%", marginTop: "10px" }} loading={loadingGroups}
//                         filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
//                         {groups.map((group) => (<Option key={group} value={group}>{group}</Option>))}
//                     </Select>
//                 )}
//             </div>

//             <div className="mb-3">
//                 <label>Titre du Sujet</label>
//                 <Checkbox checked={isNewTitle} onChange={(e) => setIsNewTitle(e.target.checked)} style={{ marginLeft: "10px" }}>
//                     Nouveau sujet ?
//                 </Checkbox>

//                 {isNewTitle ? (
//                     <Input type="text" name="title" className="form-control" value={subject.title}
//                         onChange={handleInputChange} required style={{ marginTop: "10px" }} />
//                 ) : (
//                     <Select showSearch className="form-control" value={subject.title || undefined}
//                         onChange={(value) => setSubject((prev) => ({ ...prev, title: value }))}
//                         placeholder="Sélectionnez un sujet" style={{ width: "100%", marginTop: "10px" }}
//                         loading={loadingTitles} disabled={!subject.group_name}
//                         filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
//                         {titleOptions.map((title) => (<Option key={title} value={title}>{title}</Option>))}
//                     </Select>
//                 )}
//             </div>

//             <div className="mb-3">
//                 <label>Sous-titre du Sujet</label>
//                 <Input type="text" name="subTitle" className="form-control" value={subject.subTitle} onChange={handleInputChange} />
//             </div>

//             <div className="mb-3">
//                 <label>Contenu du </label>
//                 <Editor 
//                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle" 
//                     value={subject.content}
//                     onInit={(evt, editor) => (editorRef.current = editor)} 
//                     onEditorChange={handleEditorChange} 
//                     init={tinyMCEInit} 
//                 />
//             </div>

//             <Button type="primary" htmlType="submit" block loading={loading} disabled={success}>
//                 {success ? "Succès" : "Enregistrer"}
//             </Button>
//         </form>
//     );
// };

// export default AddSubjectForm;






// ********** AddSubjectForm.jsx - Version OPTIMISÉE avec endpoint léger *****************
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { Checkbox, Select, Input, Button, message } from "antd";
import courseService from "../../services/course.service";
import API_BASE from "../../config/apiConfig";

const { Option } = Select;

const PROXY_BASE_URL = `${API_BASE}/images/proxy?url=`;
const METADATA_URL = `${API_BASE}/images/metadata/`;

const getProxyUrl = (fileId) => {
    const downloadUrl = `https://drive.google.com/uc?id=${fileId}&export=view`;
    return PROXY_BASE_URL + encodeURIComponent(downloadUrl);
};

const isGoogleDriveUrl = (url) => {
    if (!url) return false;
    return url.includes('drive.google.com') || 
           url.includes('drive.usercontent.google.com') ||
           url.includes('googleapis.com/drive');
};

const extractFileId = (url) => {
    if (!url) return null;
    let match = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) ||
                url.match(/[?&]id=([a-zA-Z0-9_-]+)/) ||
                url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : null;
};

const transformExistingSrc = (content) => {
    if (!content || typeof content !== 'string') return content;
    
    let transformed = content
        .replace(/http:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
        .replace(/https:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
        .replace(/http:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
        .replace(/https:\/\/localhost:8080\/api\//g, `${API_BASE}/`);
    
    transformed = transformed
        .replace(/src="\/api\//g, `src="${API_BASE}/`)
        .replace(/src='\/api\//g, `src='${API_BASE}/`)
        .replace(/href="\/api\//g, `href="${API_BASE}/`)
        .replace(/href='\/api\//g, `href='${API_BASE}/`);
    
    transformed = transformed.replace(
        /<video([^>]*)>/gi,
        (match, attrs) => {
            let newAttrs = attrs.replace(/controlsList="[^"]*"/gi, '').replace(/controlslist="[^"]*"/gi, '');
            newAttrs += ' controlsList="nodownload nofullscreen noremoteplayback"';
            if (!attrs.includes('disablePictureInPicture')) newAttrs += ' disablePictureInPicture';
            if (!attrs.includes('oncontextmenu')) newAttrs += ' oncontextmenu="return false;"';
            newAttrs = newAttrs.replace(/\s+/g, ' ').trim();
            return `<video ${newAttrs}>`;
        }
    );
    
    transformed = transformed.replace(
        /(<img[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
        (match, prefix, url, suffix) => {
            if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
                const fileId = extractFileId(url);
                if (fileId) return prefix + getProxyUrl(fileId) + suffix;
            }
            return match;
        }
    );
    
    transformed = transformed.replace(
        /(<source[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
        (match, prefix, url, suffix) => {
            if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
                const fileId = extractFileId(url);
                if (fileId) return prefix + getProxyUrl(fileId) + suffix;
            }
            return match;
        }
    );
    
    transformed = transformed.replace(
        /(<video[^>]+src=["'])(https?:\/\/[^"']+)(["'][^>]*>)/gi,
        (match, prefix, url, suffix) => {
            if (isGoogleDriveUrl(url) && !url.includes('/images/proxy')) {
                const fileId = extractFileId(url);
                if (fileId) return prefix + getProxyUrl(fileId) + suffix;
            }
            return match;
        }
    );
    
    return transformed;
};

const AddSubjectForm = ({ courseId: propCourseId, subject: existingSubject, onClose, onSaved }) => {
    const params = useParams();
    const navigate = useNavigate();
    const courseId = propCourseId || params.courseId || existingSubject?.courseId;
    
    const [subject, setSubject] = useState({
        group_name: existingSubject?.group_name || "",
        title: existingSubject?.title || "",
        subTitle: existingSubject?.subTitle || "",
        content: existingSubject?.content || "",
    });
    
    const [groups, setGroups] = useState([]);
    const [isNewGroup, setIsNewGroup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingGroups, setLoadingGroups] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [isNewTitle, setIsNewTitle] = useState(false);
    const [titleOptions, setTitleOptions] = useState([]);
    const [loadingTitles, setLoadingTitles] = useState(false);
    const [initialLoadDone, setInitialLoadDone] = useState(false);
    const [lightData, setLightData] = useState([]);
    const editorRef = useRef(null);

    useEffect(() => {
        if (existingSubject) {
            const transformedContent = transformExistingSrc(existingSubject.content || "");
            setSubject({
                group_name: existingSubject.group_name || "",
                title: existingSubject.title || "",
                subTitle: existingSubject.subTitle || "",
                content: transformedContent,
            });
        }
    }, [existingSubject]);

    useEffect(() => {
        const fetchGroupsLight = async () => {
            setLoadingGroups(true);
            try {
                const response = await axios.get(`${API_BASE}/courses/${courseId}/subjects/light`, {
                    headers: authHeader()
                });
                const data = response.data || [];
                setLightData(data);
                
                const uniqueGroups = [...new Set(data.map((s) => s.group_name).filter(Boolean))];
                setGroups(uniqueGroups);
                
                if (subject.group_name) {
                    const filteredTitles = data
                        .filter((s) => s.group_name === subject.group_name)
                        .map((s) => s.title)
                        .filter(Boolean);
                    setTitleOptions([...new Set(filteredTitles)]);
                }
                setInitialLoadDone(true);
            } catch (err) {
                if (err.response?.status !== 204) {
                    console.error("Erreur lors de la récupération des groupes :", err);
                }
                setInitialLoadDone(true);
            } finally {
                setLoadingGroups(false);
            }
        };
        if (courseId) fetchGroupsLight();
    }, [courseId]);

    useEffect(() => {
        if (!initialLoadDone || !subject.group_name) return;
        
        const filteredTitles = lightData
            .filter((s) => s.group_name === subject.group_name)
            .map((s) => s.title)
            .filter(Boolean);
        const uniqueTitles = [...new Set(filteredTitles)];
        setTitleOptions(uniqueTitles);
        
        if (subject.group_name && !uniqueTitles.includes(subject.title)) {
            setSubject((prev) => ({ ...prev, title: "" }));
        }
    }, [subject.group_name, lightData, initialLoadDone]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubject((prev) => ({ ...prev, [name]: value }));
    };

    const handleGroupChange = (value) => {
        setSubject((prev) => ({ ...prev, group_name: value }));
    };

    const handleCheckboxChange = (e) => {
        setIsNewGroup(e.target.checked);
        if (!e.target.checked) setSubject((prev) => ({ ...prev, group_name: "" }));
    };

    const getFileMetadata = async (fileId) => {
        try {
            const response = await axios.get(METADATA_URL + fileId);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur récupération métadonnées:", error);
            return null;
        }
    };

    const processGoogleDriveLink = async (fileId, fullUrl) => {
        try {
            const metadata = await getFileMetadata(fileId);
            
            if (!metadata || metadata.error) {
                message.error("⚠️ Fichier non accessible.");
                return `<p style="color: red;">⚠️ Fichier non accessible (ID: ${fileId})</p>`;
            }

            const mimeType = metadata.mimeType || 'application/octet-stream';
            const fileName = metadata.name || 'Fichier';
            const fileSize = parseInt(metadata.size) || 0;
            const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);
            
            const proxyUrl = getProxyUrl(fileId);

            if (mimeType.startsWith("image/")) {
                message.success(`🖼️ Image "${fileName}" ajoutée !`);
                return `<p><img src="${proxyUrl}" alt="${fileName}" style="width: 100%; max-width: 800px; height: auto; border-radius: 10px;" /></p>`;
                
            } else if (mimeType.startsWith("video/")) {
                message.success(`🎬 Vidéo "${fileName}" (${fileSizeMB} MB) ajoutée !`);
                // ✅ FIX — utiliser <p> avec text-align pour que TinyMCE puisse aligner
                return `<p style="text-align: center;">
                    <video playsinline controls style="width: 100%; max-width: 800px; border-radius: 10px; display: inline-block;">
                        <source src="${proxyUrl}" type="${mimeType}" />
                    </video>
                </p>
                <p style="text-align: center; font-size: 12px; color: #666;">🎬 ${fileName}</p>`;
                
            } else if (mimeType === "application/pdf") {
                message.success(`📄 PDF "${fileName}" ajouté !`);
                return `<p><a href="${proxyUrl}" target="_blank" rel="noopener" style="color: #1890ff; text-decoration: underline; font-weight: bold;">📄 Ouvrir le PDF : ${fileName}</a></p>`;
                
            } else if (mimeType.startsWith("audio/")) {
                message.success(`🎵 Audio "${fileName}" (${fileSizeMB} MB) ajouté !`);
                return `<audio controls preload="metadata" style="width: 100%; max-width: 500px; margin: 10px 0;">
                    <source src="${proxyUrl}" type="${mimeType}" />
                </audio>`;
                
            } else {
                message.info(`📎 Fichier "${fileName}" ajouté comme lien`);
                return `<p><a href="${proxyUrl}" target="_blank" rel="noopener" style="color: #1890ff;">📎 Télécharger : ${fileName}</a></p>`;
            }
        } catch (error) {
            console.error("❌ Erreur traitement fichier:", error);
            message.error("⚠️ Erreur lors du traitement du fichier");
            return `<p style="color: red;">⚠️ Erreur: ${error.message}</p>`;
        }
    };

    const handleEditorChange = async (value, editor) => {
        const googleDriveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)(\/view[^\s<"]*)?/g;
        const matches = [...value.matchAll(googleDriveRegex)];
        
        if (matches.length === 0) {
            setSubject((prev) => ({ ...prev, content: value }));
            return;
        }

        let processedValue = value;
        
        for (const match of matches) {
            const fullUrl = match[0];
            const fileId = match[1];
            
            const beforeMatch = value.substring(0, match.index);
            if (beforeMatch.endsWith('src="') || 
                beforeMatch.endsWith("src='") || 
                beforeMatch.includes(`/file/d/${fileId}/preview`) ||
                beforeMatch.includes(`id=${fileId}`) ||
                beforeMatch.endsWith('href="')) {
                continue;
            }
            
            const embeddedContent = await processGoogleDriveLink(fileId, fullUrl);
            processedValue = processedValue.replace(fullUrl, embeddedContent);
        }
        
        processedValue = transformExistingSrc(processedValue);
        setSubject((prev) => ({ ...prev, content: processedValue }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!subject.group_name || !subject.title) {
            setError("Veuillez remplir tous les champs requis.");
            setLoading(false);
            return;
        }

        try {
            const dataToSave = {
                ...subject,
                content: transformExistingSrc(subject.content),
                courseId
            };

            if (existingSubject?.id) {
                await courseService.updateSubject(existingSubject.id, dataToSave);
            } else {
                await courseService.addSubjectToCourse(courseId, dataToSave);
            }

            setSuccess(true);
            if (onSaved) await onSaved();
            
            setTimeout(() => {
                if (onClose) onClose();
                else navigate("/mod/courses");
            }, 1000);
        } catch (err) {
            setError(err.message || "Une erreur s'est produite.");
        } finally {
            setLoading(false);
        }
    };

    const tinyMCEInit = {
        height: 500,
        menubar: true,
        plugins: [
            "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
            "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
            "insertdatetime", "media", "table", "help", "wordcount"
        ],
        toolbar: `undo redo | bold italic underline strikethrough | link image media |
            alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
            removeformat code help`,
        content_style: `
            body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }

            /* Vidéo de base */
            video {
                max-width: 100%;
                border-radius: 10px;
                background: #000;
                min-height: 200px;
                display: inline-block;
            }

            /* ✅ FIX ALIGNEMENT — les boutons gauche/centre/droite fonctionnent */
            p[style*="text-align: center"] video,
            p[style*="text-align:center"] video {
                display: inline-block;
                margin: 0 auto;
            }
            p[style*="text-align: left"] video,
            p[style*="text-align:left"] video {
                display: inline-block;
                margin-right: auto;
            }
            p[style*="text-align: right"] video,
            p[style*="text-align:right"] video {
                display: inline-block;
                margin-left: auto;
            }

            audio { max-width: 100%; border-radius: 10px; }
            .video-container { background: #f5f5f5; padding: 10px; border-radius: 10px; border: 1px solid #ddd; }
            video::-internal-media-controls-download-button { display: none !important; }
            video::-webkit-media-controls-download-button { display: none !important; }
            video::-webkit-media-controls-enclosure { overflow: hidden !important; }
            video::-webkit-media-controls-panel { width: calc(100% + 30px) !important; }
            video::-moz-media-controls-download-button { display: none !important; }
            video { -webkit-user-select: none !important; -moz-user-select: none !important; user-select: none !important; -webkit-touch-callout: none !important; -webkit-user-drag: none !important; }
        `,
        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,
        extended_valid_elements: 'video[controls|controlsList|controlslist|oncontextmenu|disablePictureInPicture|disablepictureinpicture|preload|style|src|type|width|height|id|class],audio[controls|controlsList|preload|style],source[src|type],div[class|style],p[style]',
        custom_elements: 'video,audio,source',
        valid_children: '+body[video|audio|div],+div[video|audio|div|p],+p[video|audio|span]',
        media_live_embeds: true,
        media_alt_source: false,
        media_poster: false,
        setup: (editor) => {
            // ✅ FIX ALIGNEMENT VIDÉO — intercepter les boutons align de TinyMCE
            editor.on('ExecCommand', (e) => {
                const alignCommands = ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyFull'];
                if (!alignCommands.includes(e.command)) return;

                const node = editor.selection.getNode();
                // Chercher le <p> parent qui contient la vidéo
                const pNode = node.tagName === 'P' ? node : node.closest('p');
                if (!pNode) return;

                const video = pNode.querySelector('video');
                if (!video) return;

                // Appliquer text-align sur le <p>
                if (e.command === 'JustifyCenter') {
                    pNode.style.textAlign = 'center';
                } else if (e.command === 'JustifyRight') {
                    pNode.style.textAlign = 'right';
                } else if (e.command === 'JustifyLeft') {
                    pNode.style.textAlign = 'left';
                } else if (e.command === 'JustifyFull') {
                    pNode.style.textAlign = 'justify';
                }
            });

            editor.on('BeforeSetContent', (e) => {
                if (e.content) e.content = transformExistingSrc(e.content);
            });

            editor.on('NodeChange', () => {
                const images = editor.dom.select('img');
                images.forEach(img => {
                    const src = img.getAttribute('src');
                    if (isGoogleDriveUrl(src) && !src.includes('/api/images/proxy')) {
                        const fileId = extractFileId(src);
                        if (fileId) img.setAttribute('src', getProxyUrl(fileId));
                    }
                });
            });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>{existingSubject ? "Modifier le sujet" : "Ajouter un sujet"}</h3>
            
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">
                {existingSubject ? "Sujet mis à jour avec succès !" : "Sujet ajouté avec succès !"}
            </div>}

            <div className="mb-3">
                <label>Nom du Groupe</label>
                <Checkbox checked={isNewGroup} onChange={handleCheckboxChange} style={{ marginLeft: "10px" }}>
                    Nouveau groupe ?
                </Checkbox>

                {isNewGroup ? (
                    <Input type="text" name="group_name" className="form-control" value={subject.group_name}
                        onChange={handleInputChange} required style={{ marginTop: "10px" }} />
                ) : (
                    <Select showSearch className="form-control" value={subject.group_name || undefined}
                        onChange={handleGroupChange} placeholder="Sélectionnez un groupe"
                        style={{ width: "100%", marginTop: "10px" }} loading={loadingGroups}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                        {groups.map((group) => (<Option key={group} value={group}>{group}</Option>))}
                    </Select>
                )}
            </div>

            <div className="mb-3">
                <label>Titre du Sujet</label>
                <Checkbox checked={isNewTitle} onChange={(e) => setIsNewTitle(e.target.checked)} style={{ marginLeft: "10px" }}>
                    Nouveau sujet ?
                </Checkbox>

                {isNewTitle ? (
                    <Input type="text" name="title" className="form-control" value={subject.title}
                        onChange={handleInputChange} required style={{ marginTop: "10px" }} />
                ) : (
                    <Select showSearch className="form-control" value={subject.title || undefined}
                        onChange={(value) => setSubject((prev) => ({ ...prev, title: value }))}
                        placeholder="Sélectionnez un sujet" style={{ width: "100%", marginTop: "10px" }}
                        loading={loadingTitles} disabled={!subject.group_name}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                        {titleOptions.map((title) => (<Option key={title} value={title}>{title}</Option>))}
                    </Select>
                )}
            </div>

            <div className="mb-3">
                <label>Sous-titre du Sujet</label>
                <Input type="text" name="subTitle" className="form-control" value={subject.subTitle} onChange={handleInputChange} />
            </div>

            <div className="mb-3">
                <label>Contenu du </label>
                <Editor 
                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle" 
                    value={subject.content}
                    onInit={(evt, editor) => (editorRef.current = editor)} 
                    onEditorChange={handleEditorChange} 
                    init={tinyMCEInit} 
                />
            </div>

            <Button type="primary" htmlType="submit" block loading={loading} disabled={success}>
                {success ? "Succès" : "Enregistrer"}
            </Button>
        </form>
    );
};

export default AddSubjectForm;